import React from 'react';
import { get } from 'lodash';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';
import { isGa2Device } from 'common/utils/deviceTwinUtils';
import styles from './DeviceStatusBox.module.css';

const deviceStatuses = {
  OFFLINE: 0,
  COMMISSIONED: 1,
  LOCKED: 2
};

const DeviceStatusBox = ({ device }) => {
  const connectionState = get(device, 'connectionState');
  const isCommissioned = get(device, 'tags.bundle.commissioned', false);
  const isGA2 = isGa2Device(device);
  const adminState = get(device, 'properties.reported.adminState', 'N/A');
  const getStatuses = () => {
    let statuses = [];

    statuses.push(connectionState === 'Connected');
    statuses.push(isCommissioned);

    const lockedStates = ['locked', 'lock'];
    statuses.push(lockedStates.includes(adminState));

    return <div className={styles.statuses}>{statuses.map((status, index) => getSingleStatus(status, index))}</div>;
  };

  const getSingleStatus = (statusValue, index) => {
    let currIcon = null;
    let tooltip = '';

    switch (index) {
      case deviceStatuses.OFFLINE:
        currIcon = statusValue ? IconLoader.icon_connected : IconLoader.icon_offline;
        tooltip = connectionState;
        break;
      case deviceStatuses.COMMISSIONED:
        if (isGA2) {
          currIcon = IconLoader.icon_commissioned_gray;
          tooltip = 'N/A';
        } else {
          currIcon = statusValue ? IconLoader.icon_commissioned : IconLoader.icon_not_commissioned;
          tooltip = statusValue ? 'Commissioned' : 'Not commissioned';
        }
        break;
      case deviceStatuses.LOCKED:
        if (adminState === 'N/A') {
          currIcon = statusValue ? IconLoader.icon_locked_device : IconLoader.icon_locked_device_off;
          tooltip = 'N/A';
        } else {
          currIcon = statusValue ? IconLoader.icon_locked_device : IconLoader.icon_unlocked_default;
          tooltip = statusValue
            ? 'Locked'
            : adminState.substring(0, 1).toUpperCase() + adminState.substring(1).toLowerCase();
        }
        break;
      default:
        break;
    }

    return (
      <div className={styles.singleStatus} key={index}>
        <SvgAF img={currIcon} scaleImg={true} tooltip={tooltip} />
      </div>
    );
  };
  return getStatuses();
};

export default DeviceStatusBox;
